import { Flex } from '@rebass/grid';
import { APP_STORE_URL, PLAY_STORE_URL } from 'config';
import React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PlatformService from 'services/platform';

import { Container, Divider, Text } from './styles';

interface Props {
  coinName: string;
}

const AppBanner = (props: Props) => {
  const { coinName } = props;
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);
  const [useShortText, setUseShortText] = useState<boolean>(false);

  const resizeHandler = () => {
    if (ref.current === null) {
      return;
    }

    const { width } = ref.current.getBoundingClientRect();
    setUseShortText(width < 450);
  };

  useEffect(() => {
    window.addEventListener('resize', resizeHandler);

    return function cleanup() {
      window.removeEventListener('resize', resizeHandler);
    };
  });

  const onClick = () => {
    if (PlatformService.isIos) {
      window.location.replace(APP_STORE_URL);
      return;
    }

    if (PlatformService.isAndroid) {
      window.location.replace(PLAY_STORE_URL);
      return;
    }

    window.location.href = '/download';
  };

  return (
    <Container ref={ref} onClick={onClick}>
      <Flex py="16px" alignItems="center" flex={1}>
        {useShortText ? (
          <Text>{t('app-banner.title-short')}</Text>
        ) : (
          <Text>{t('app-banner.title', { coinName })}</Text>
        )}
      </Flex>
      <img src="/static/images/banners/phones.png" width={180} />
      <Flex flexDirection="column" justifyContent="center" alignItems="center">
        <Flex flex="1" alignItems="center">
          <img src="/static/images/banners/apple-logo.png" width={78} />
        </Flex>
        <Divider />
        <Flex flex="1" alignItems="center">
          <img src="/static/images/banners/playstore-logo.png" width={82} />
        </Flex>
      </Flex>
    </Container>
  );
};

export default AppBanner;
